import { AttachmentsAdditionalProperties, AttachmentsDef } from "@components/smart/GeneralFieldDefinition";
import {
    EntitySetName,
    EntityTypeName,
    FiscalYearCloseAdvanceTaxEntity,
    FiscalYearCloseEntity,
    FiscalYearCloseExchangeRateEntity,
    FiscalYearCloseInventoryEntity,
    FiscalYearCloseSectionEntity,
    UserEntity,
} from "@odata/GeneratedEntityTypes";
import { DocumentTypeCode } from "@odata/GeneratedEnums";
import { setDefForTesting } from "@pages/getDefByEntityType";

import { IFormDef } from "../../views/formView/Form";
import { IDefinition, IGetDefinition } from "../PageUtils";
import { documentProps } from "./FiscalYearClose.utils";

export const getDefinitions: IGetDefinition = (): IDefinition => {
    const form: IFormDef = {
        id: `${EntityTypeName.FiscalYearClose}Form`,
        files: AttachmentsDef,
        translationFiles: getDefinitions.translationFiles,
        fieldDefinition: {},
        additionalProperties: [
            {
                id: FiscalYearCloseEntity.ExchangeRates,
                additionalProperties: [
                    {
                        id: FiscalYearCloseExchangeRateEntity.CurrencyCode,
                    },
                ],
            },
            { id: FiscalYearCloseEntity.TaxSavingsAmount },
            { id: FiscalYearCloseEntity.ExpenseTaxRateCode },
            { id: FiscalYearCloseEntity.InventoryTypeCode },
            { id: FiscalYearCloseEntity.HasTaxAdvisor },
            { id: FiscalYearCloseEntity.DateClosed },
            { id: FiscalYearCloseEntity.LegalEntityCategoryCode },
            { id: FiscalYearCloseEntity.IsIncomeTaxAmountPosted },
            {
                id: FiscalYearCloseEntity.Sections,
                additionalProperties: [
                    {
                        id: FiscalYearCloseSectionEntity.IsChecked,
                    },
                    {
                        id: FiscalYearCloseSectionEntity.Type,
                    },
                ],
            },
            { id: FiscalYearCloseEntity.ClosedByUser, additionalProperties: [{ id: UserEntity.Name }] },
            documentProps(FiscalYearCloseEntity.BalanceSheetClose),
            documentProps(FiscalYearCloseEntity.IncomeExpenseTransfer),
            documentProps(FiscalYearCloseEntity.NextYearBalanceSheetOpen),
            documentProps(FiscalYearCloseEntity.NextYearProfitOrLossTransfer),
            documentProps(FiscalYearCloseEntity.ProfitOrLoss),
            documentProps(FiscalYearCloseEntity.ExchangeRateDocuments),
            documentProps(FiscalYearCloseEntity.IncomeTaxDocument),
            documentProps(FiscalYearCloseEntity.InventoryClearingDocument),
            documentProps(FiscalYearCloseEntity.InventoryCheckDocument),
            // is always OtherLiability or OtherReceivable, but Document type in oData so we can't use expand for DateDue
            documentProps(FiscalYearCloseEntity.IncomeTaxPaymentOrReturnDocument, DocumentTypeCode.OtherLiability),
            { id: FiscalYearCloseEntity.IncomeTaxAmount },
            { id: FiscalYearCloseEntity.IncomeTaxPaidAdvanceAmount },
            { id: FiscalYearCloseEntity.IsAudited },
            { id: FiscalYearCloseEntity.IsSubmissionViaMojeDane },
            {
                id: FiscalYearCloseEntity.InventoryAccounts,
                additionalProperties: [
                    {
                        id: FiscalYearCloseInventoryEntity.Amount,
                    },
                    {
                        id: FiscalYearCloseInventoryEntity.InventoryAccount,
                    },
                    {
                        id: FiscalYearCloseInventoryEntity.ConsumptionAccount,
                    },
                    {
                        id: FiscalYearCloseInventoryEntity.ChartOfAccounts,
                    },
                ],
            },
            {
                id: FiscalYearCloseEntity.AdvanceTaxPayments,
                additionalProperties: [
                    { id: FiscalYearCloseAdvanceTaxEntity.Amount },
                    { id: FiscalYearCloseAdvanceTaxEntity.DateAccountingTransaction },
                    { id: FiscalYearCloseAdvanceTaxEntity.DateDue },
                    documentProps(
                        FiscalYearCloseAdvanceTaxEntity.CreatedDocument,
                        DocumentTypeCode.OtherLiability,
                        true
                    ),
                ],
            },
            {
                id: FiscalYearCloseEntity.TaxStatementXmlAttachments,
                additionalProperties: [
                    { id: "File/Name" },
                    { id: "File/Size" },
                    { id: "File/DateCreated" },
                    { id: "File/DateLastModified" },
                    { id: "File/IsIsdocReadable" },
                    { id: "File/IsRossumReadable" },
                    { id: "Description" },
                ],
            },
            ...AttachmentsAdditionalProperties,
        ],
    };

    return {
        form,
        entitySet: EntitySetName.FiscalYearCloses,
    };
};

getDefinitions.translationFiles = [];
setDefForTesting(EntityTypeName.FiscalYearClose, getDefinitions);

